/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_EmptyInputs */

const en_home_empty = /** @type {(inputs: Home_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No apartments available right now. Please check back soon.`)
};

/**
* | output |
* | --- |
* | "No apartments available right now. Please check back soon." |
*
* @param {Home_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_empty = /** @type {((inputs?: Home_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_empty(inputs)
});